import React from "react";
import { anatomyConfig } from "../../utilities/config/anatomyConfig";
import { BodyPartAnalysis } from "../../utilities/types/size-guide";

interface BodyAnalysisVisualizerProps {
  analysis: {
    [key: string]: BodyPartAnalysis | string;
  };
  selectedSize: string;
  gender: "men" | "women" | "genderfree";
}

const BodyAnalysisVisualizer: React.FC<BodyAnalysisVisualizerProps> = ({ analysis, selectedSize, gender }) => {
  // analysis = {
  //   Neck: "15",
  //   Shoulder: "15",
  //   Chest: "15",
  //   UnderChest: "15",
  //   Cup: "15",
  //   Bust: "15",
  //   UnderBust: "15",
  //   Waist: "15",
  //   Hip: "15",
  //   Thigh: "15",
  //   Leg: "15",
  //   FullArmLength: "15",
  // };

  const normalizedGender = (gender || "genderfree").toLowerCase() as keyof typeof anatomyConfig;

  const config = anatomyConfig[normalizedGender] || anatomyConfig.genderfree;

  return (
    <div className="flex flex-col items-center w-full gap-4 md:gap-8 max-w-fit">
      <div className="grid w-full grid-cols-3 gap-4 p-4 place-items-center">
        <div className="col-span-3 relative w-[21.908125rem] h-[31rem] scale-75 md:scale-100">
          <img src={config.image} alt="Body Anatomy" className="object-contain w-full h-full" />

          {Object.entries(analysis).map(([part, data]) => {
            const partConfig = config.bodyParts[part];
            if (!partConfig) return null;

            return (
              <div key={part} className={`absolute ${partConfig.position}`}>
                <img src={partConfig.icon} className={`${partConfig.size}`} alt={part} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BodyAnalysisVisualizer;
